"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSpinners = require("react-spinners");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DisabledButtonStyled = _styledComponents["default"].button.attrs(function () {
  return {
    name: "disabled-button"
  };
}).withConfig({
  displayName: "DisabledButton__DisabledButtonStyled",
  componentId: "sc-1v0p4sd-0"
})(["", " ", " ", " ", " font-size:", " !important;"], function (props) {
  return props.disabled ? "background-color: ".concat(props.theme["white"], " !important;") : "";
}, function (props) {
  return props.disabled ? "color: ".concat(props.theme["grey"], " !important;") : "";
}, function (props) {
  return props.disabled ? "border-color: ".concat(props.theme["grey"], " !important;") : "";
}, function (props) {
  return props.disabled ? "padding: ".concat(props.styles.padding, " !important;") : "";
}, function (props) {
  return props.styles.fontSize + "px";
});

var DefaultStyle = {
  color: "blue",
  spinnerSize: 20,
  padding: ".375rem .75rem",
  fontSize: "15"
};

var DisabledButton = function DisabledButton(_ref) {
  var disabled = _ref.disabled,
      loading = _ref.loading,
      children = _ref.children,
      styles = _ref.styles,
      rest = _objectWithoutProperties(_ref, ["disabled", "loading", "children", "styles"]);

  var CompStyles = _objectSpread({}, DefaultStyle, {}, styles);

  if (CompStyles.fontSize === "lg") {
    CompStyles.fontSize = "30";
  }

  if (CompStyles.fontSize === "sm") {
    CompStyles.fontSize = "12";
  }

  return _react["default"].createElement(DisabledButtonStyled, _extends({
    styles: CompStyles,
    disabled: disabled
  }, rest), loading ? _react["default"].createElement(_reactSpinners.ClipLoader, {
    size: CompStyles.spinnerSize,
    color: CompStyles.color
  }) : children);
};

DisabledButton.propTypes = {
  styles: _propTypes["default"].object,
  loading: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
DisabledButton.defaultProps = {
  styles: {},
  loading: false,
  disabled: false
};
var _default = DisabledButton;
exports["default"] = _default;